<template>
	<div class="renzheng_page">
		<div class="red_top_bg">
			<div
					class="back_left"
					@click="$router.go(-1)"
			/>
			<div class="big_tit">
				{{ $t('pagea.smrz') }}
			</div>
		</div>
		<div class="form_wrap">
			<van-form @submit="onSubmit">
			  <van-field
			    v-model="username"
			    :name="$t('pagea.xm')"
			    :label="$t('pagea.xm')"
			    :placeholder="$t('pagea.xm')"
				:disabled="sfzinfo.state==1||sfzinfo.state==2"
			    :rules="[{ required: true, message: '' }]"
			  />
			  <van-field
			    v-model="idcard"
			    type="idcard"
			    :name="$t('pagea.sfzh')"
			    :label="$t('pagea.sfzh')"
				:disabled="sfzinfo.state==1||sfzinfo.state==2"
			    :placeholder="$t('pagea.sfzh')"
			    :rules="[{ required: true, message: '' }]"
			  />
			  <van-field name="cardimg1" :label="$t('pagea.sfzzm')">
			    <template #input>
			      <van-uploader v-model="cardimg1" :after-read="afterRead" max-count="1" :disabled="sfzinfo.state==1||sfzinfo.state==2"/>
			    </template>
			  </van-field>
			  <van-field name="cardimg2" :label="$t('pagea.sfzfm')">
			    <template #input>
			      <van-uploader v-model="cardimg2" :after-read="afterRead1" max-count="1" :disabled="sfzinfo.state==1||sfzinfo.state==2"/>
			    </template>
			  </van-field>
			  <div style="margin: 16px;">
			    <van-button round block type="info" native-type="submit" 
				:disabled="sfzinfo.state==1||sfzinfo.state==2">
					<span v-if="sfzinfo.state==3">{{ $t('pagea.gx') }}</span>
					<span v-else-if="sfzinfo.state==2">{{ $t('pagea.tz') }}</span>
					<span v-else>{{ $t('utils.submit') }}</span>
				</van-button>
			  </div>
			</van-form>
		</div>
	</div>
</template>

<script>
    import Fetch from '../../utils/fetch'
	import api from "../../interface/index";
	import upload from '../../utils/upload'
	import Vue from 'vue';
	import { Form } from 'vant';
	import { Field } from 'vant';
	import { Uploader } from 'vant';
	import { Button } from 'vant';
	let domain=api.commonUrl;
	console.log(domain);
	Vue.use(Button);
	
	Vue.use(Uploader);
	
	Vue.use(Form);
	Vue.use(Field);
	export default{
		data(){
			return{
				username: '',
				idcard: '',
				sfzimg1:'',
				sfzimg2:'',
				cardimg1:[],
				cardimg2:[],
				sfzinfo:{}
			}
		},
        created() {
            this.$parent.footer('user', false);
        },
		mounted() {
			this.getinfo();
		},
		methods:{
			afterRead(file){
				 const formData = new FormData();
				formData.append('file', file.file);
				let self=this;
				upload('/index/upload',formData).then((r) => {
					self.sfzimg1=r;
				});
			},
			afterRead1(file){
				 const formData = new FormData();
				formData.append('file', file.file);
				let self=this;
				upload('/index/upload',formData).then((r) => {
					self.sfzimg2=r;
				});
			},
			getinfo(){
				Fetch('/index/getrenzheng',{}).then(r=>{
				    if(r.code==1){
						this.sfzinfo=r.data||{};
						if(this.sfzinfo.realname){
							this.username=this.sfzinfo.realname
						}
						if(this.sfzinfo.idnum){
							this.idcard=this.sfzinfo.idnum
						}
						if(this.sfzinfo.sfzimg1){
							this.sfzimg1=this.sfzinfo.sfzimg1;
							this.cardimg1=[{url:domain+'/'+this.sfzimg1}];
						}
						if(this.sfzinfo.sfzimg2){
							this.sfzimg2=this.sfzinfo.sfzimg2
							this.cardimg2=[{url:domain+'/'+this.sfzimg2}];
						}
					}
				})
			},
			onSubmit(){
				let self=this;
				let formdata={
					username:this.username,
					idcard:this.idcard,
					sfzimg1:this.sfzimg1,
					sfzimg2:this.sfzimg2
				};
				if(this.sfzinfo.id){
					formdata.id=this.sfzinfo.id;
				}
				Fetch('/index/renzheng',{
				    ...formdata
				}).then(r=>{
				    if(r.code==1){
						self.getinfo();
					}
				})
			}
		}
	}
</script>

<style lang="less" scoped>
.red_top_bg {
  height: 126px;
  position: fixed;
}
.form_wrap {
	padding-top: 56px;
}
</style>